export default {
  data () {
    return {
      features: {}
    }
  },
  created () {
    const features = window.localStorage.getItem(process.env.VUE_APP_FEATURES_LIST) || ''
    if (features) this.features = JSON.parse(this.$formatter.decryptString(features)) || {}
  },
  methods: {
    checkFeatureEnabled (name) {
      return this.features[name] ? Number(this.features[name].enabled) : true
    },
    getFeatureObj (name) {
      return this.features[name]
    },
    getCustomModules () {
      const custommodules = []
      const custommodulesList = this.$formatter.cloneVariable(this.features.custom_modules || '')
      if (custommodulesList && Object.keys(custommodulesList).length) {
        Object.values(custommodulesList).forEach(cModule => {
          if (cModule.enabled && cModule.link) {
            const iconSvg = cModule.icon_svg ?? null
            // Icon priority: SVG first (icon_svg), else the stored class icon
            // (old data — Font Awesome / mdi), else mdi-cube. A ".svg" filename
            // is not a renderable class, so it's only kept when we actually have
            // the SVG markup; otherwise it falls through to mdi-cube.
            const rawIcon = cModule.icon ?? ''
            const isSvgName = typeof rawIcon === 'string' && rawIcon.toLowerCase().endsWith('.svg')
            const icon = iconSvg ? rawIcon : (rawIcon && !isSvgName ? rawIcon : 'mdi-cube')
            custommodules.push({ icon, icon_svg: iconSvg, name: cModule.label, isCustomModules: true, link: cModule.link, slug: cModule.slug })
          }
        })
      }
      return (custommodules && custommodules.length) ? custommodules : false
    }
  }
}
